import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { Button, Container, Grid, Paper, Typography, Box } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BookingStepper from "../components/Booking/BookingStepper";
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../redux/actions/stepActions";
import {
    bookingActions,
    getNextStep,
    getPreviousStep,
    isDealerSite,
    registerBookingTrip,
    requestApi,
    showAlertAutoDis,
    validateForm
} from "../utils/utils";
import { PaymentHeaderStripe, PaymentHeaderFlywire } from "../components/Booking/Payment/PaymentNew";
import TripSummary from "../components/Booking/Summary/TripSummary";
import { getTripById } from "../redux/actions/tripActions";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import CheckoutForm from "../components/Booking/Payment/CheckoutForm";
import CheckoutFormFlywire from "../components/Booking/Payment/CheckoutFormFlywire";
import { getActivitiesByTrip } from "../redux/actions/activitiesActions";
import { setTotals } from "../redux/actions/totalActions";
import { useAuthUser, useIsAuthenticated } from "react-auth-kit";
import GuestBar from "../components/GuestInfo/GuestBar";
import * as yup from "yup";
import Icon from "@mui/material/Icon";

let billingDetailsValidation = yup.object().shape({
    country: yup.string().required('The country is required'),
    state: yup.string().required('The state is required'),
    address_city: yup.string().required('The city is required'),
    address_line1: yup.string().required('The address is required'),
    address_zip: yup.string().required('The Zip code is required'),
    name: yup.string().required('The Name is required'),
    email: yup.string().required('The Email is required'),
});

const PaymentPageNew = () => {
    const { bookingId } = useParams();
    const { data: trip } = useSelector(state => state.trip);
    const step = useSelector(state => state.step);
    const dispatch = useDispatch();
    const [booking, setBooking] = useState({});
    const [paySchedule, setPaySchedule] = useState({});
    const [payThisMuch, setPayThisMuch] = useState(0.0);
    const [stripePromise, setStripePromise] = useState(false);
    const [billingDetails, setBillingDetails] = useState({
        country: '',
        state: '',
        address_city: '',
        address_line1: '',
        address_line2: '',
        address_zip: '',
        email: '',
        name: ''
    });
    const { stripeKey } = window;
    const [allowPay, setAllowPay] = useState(false);
    const [message, setMessage] = useState('');
    const [expanded, setExpanded] = useState('panel1');
    const history = useHistory();
    const isAuth = useIsAuthenticated();
    const prevStep = getPreviousStep(step);
    const user = useAuthUser();
    const splitName = billingDetails.name.split(' ');
    const bookingType = useSelector(state => state.bookingType);
    const transactions = useSelector(state => state.transactions);
    const selectedRooms = transactions?.selectedRooms || [];
    const totals = useSelector((state) => state.totals);
    const {siteUrl} = window;

    const handleChangeAccordeon = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const sendStripeToken = async (token) => {
		if (!await validateForm(billingDetailsValidation, billingDetails, 'Billing Details Form')) return;
        const paymentData = {
                amount: payThisMuch,
                billingDetails
            };
            const {
                name,
                brand,
                address_line1,
                address_city,
                address_zip,
                cvc_check,
                address_zip_check,
                country,
                last4
            } = token.card;
            paymentData.cardInfo = {
                name,
                brand,
                address_line1,
                address_city,
                address_zip,
                cvc_check,
                address_zip_check,
                country,
                last4
            };
            paymentData.token = token.id
            paymentData.created = token.created;
            await requestApi(`/booking/payment/${bookingId}`, 'POST', paymentData, ({ data }) => {
                let successPayment = false;
                if ('status' in data && data['status'] === 'success') {
                    successPayment = !!data['successPayment'];
                    if (successPayment)
                        goToConfirmation();
                } else if ('message' in data)
                    showAlertAutoDis({ title: 'Error', text: data['message'] });
            });
    };

    const setDetails = (event) => {
        setBillingDetails({ ...billingDetails, [event.target.name]: event.target.value });
    };

    async function getBooking() {
        const { data } = await requestApi(`/booking/get/${bookingId}`);
        if ('status' in data && data['status'] === 'success') {
            if (Object.keys(data['booking']).length > 0) {
                setBooking(data['booking']);
                if (trip?.TripId !== parseInt(data['booking']['TripId']))
                    dispatch(getTripById(data['booking']['TripId']));
            }
            if (Object.keys(data['paySchedule']).length > 0)
                setPaySchedule(data['paySchedule']);
            if (Object.keys(data['transactions']).length > 0)
                sessionStorage.setItem('transactions', JSON.stringify(data['transactions']));
        }
    }

    useEffect(() => {
        // const stepNum = getStepFromUrl(history.location.pathname);
        const stepNum = 6;
        // TODO: Fix this
        dispatch(setStep(stepNum));
        setStripePromise(loadStripe(stripeKey));
        setEmailAndName();
        if (Object.keys(booking).length === 0)
            getBooking().catch();
        registerBookingTrip();
    }, []);

    useEffect(() => {
        if (Object.keys(booking).length > 0)
            requestApi(`/booking/check-to-pay/${booking.id}`, 'POST', null, ({ data }) => {
                if (data.status === 'success') {
                    const allow = !!data['allowed_payment'];
                    setAllowPay(allow);
                    if (!allow && data.message)
                        setMessage(data.message);
                }
            }).catch();
    }, [booking?.id]);

    useEffect(() => {
        if (trip?.TripId) {
            dispatch(getActivitiesByTrip(trip.TripId))
                .then(() => {
                    dispatch(setTotals());
                });
        }
    }, [trip?.TripId]);

    const setEmailAndName = () => {
        const name = user().firstName + ' ' + user().lastName || '';
        const email = user().email || '';
        setBillingDetails({ ...billingDetails, email, name });
    };

    function goToConfirmation() {
        const currentStep = getNextStep(step-1);
        bookingActions(
            currentStep.label,
            'Next Step',
            `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
            trip.locationInfo.location,
            trip.boarddate,
            parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
        history.push(`/booking/confirmation/${bookingId}`);
    }

    const goBack = () => {
        history.push(`/booking/${booking?.TripId}${prevStep.url}`);
    };

    const sendFlywireToken = async (token) => {
        const paymentData = {
            amount: payThisMuch,
            billingDetails: {
                name: billingDetails['name'],
                email: billingDetails['email'],
            }
        };
        const {
            amount,
            amountCurrency,
            digits,
            expirationMonth,
            expirationYear,
            payerAmount,
            payerAmountCurrency,
            paymentMethod,
            reference,
            sig,
            status,
        } = token;
        paymentData.cardInfo = {
            amount,
            amountCurrency,
            digits,
            expirationMonth,
            expirationYear,
            payerAmount,
            payerAmountCurrency,
            paymentMethod,
            reference,
            sig,
            status,
        };
        paymentData.token = token.token;


        await requestApi(`paymentFlywire/${bookingId}`, 'POST', paymentData, ({ data }) => {
            let successPayment = false;

            if ('status' in data && data['status'] === 'success') {
                successPayment = !!data['successPayment'];
                if (successPayment)
                    goToConfirmation();
            } else if ('message' in data)
                showAlertAutoDis({ title: 'Error', text: data['message'] });
        });
    };


    return (
        <div>
            {isAuth() && <GuestBar />}
            <Container maxWidth="lg">
                <BookingStepper />
                <div style={{ marginTop: 50 }} />
                {booking && Object.keys(booking).length > 0 && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={9} flexDirection="column">
                            <Typography variant="h3" component="h3" style={{ margin: '0 0 20px 0', textAlign: 'center' }}>
                                Make a Secure Payment Now
                            </Typography>
                            <Box sx={{ backgroundColor: '#E7EBF0', padding: '20px', borderRadius: '10px' }}>
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAccordeon('panel1')} sx={{ backgroundColor: '#FFF', marginBottom: '20px' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{ fontSize: '26px !important' }} />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography variant="h6" component="h6" sx={{ fontSize: '20px', fontWeight: '400' }}>
                                            USD Payment
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {paySchedule && Object.keys(paySchedule).length > 0 && allowPay &&
                                            <PaymentHeaderStripe
                                                paySchedule={paySchedule['payschedule']}
                                                payThisMuch={payThisMuch}
                                                setPayThisMuch={value => setPayThisMuch(parseFloat(value))}
                                                allowCustomPay={parseInt(booking['Type']) === 2}
                                            />
                                        }
                                        {payThisMuch > 0 &&
                                            <div style={{ marginTop: 30 }}>
                                                <Typography align={'center'} id="transition-modal-title" variant={'h3'}>Pay Now
                                                    ${payThisMuch.formatMoney()} USD
                                                </Typography>
                                                {stripePromise &&
                                                    <Elements stripe={stripePromise}>
                                                        <CheckoutForm
                                                            setBilling={setDetails}
                                                            billingDetails={billingDetails}
                                                            sendStripeToken={sendStripeToken}
                                                        />
                                                    </Elements>
                                                }
                                            </div>
                                        }
                                        {!allowPay && message && <Typography align={'center'} variant={'body1'}>
                                            <Icon sx={{ fontSize: '140px', marginTop: '20px', marginBottom: '20px' }}>warning_amber</Icon><br />
                                            {message}
                                        </Typography>}
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel2'} onChange={handleChangeAccordeon('panel2')} sx={{ backgroundColor: '#FFF' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{ fontSize: '26px !important' }} />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                    >
                                        <Typography variant="h6" component="h6" sx={{ fontSize: '20px', fontWeight: '400' }}>
                                            Local Currency Payment
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {paySchedule && Object.keys(paySchedule).length > 0 && allowPay &&
                                            <PaymentHeaderFlywire
                                                paySchedule={paySchedule['payschedule']}
                                                payThisMuch={payThisMuch}
                                                setPayThisMuch={value => setPayThisMuch(parseFloat(value))}
                                                allowCustomPay={parseInt(booking['Type']) === 2}
                                            />
                                        }
                                        {payThisMuch > 0 &&
                                            <div style={{ marginTop: 30 }}>
                                                <Typography align={'center'} id="transition-modal-title" variant={'h3'}>Pay Now
                                                    ${payThisMuch.formatMoney()} USD
                                                </Typography>
                                                <CheckoutFormFlywire
                                                    bookingId={bookingId}
                                                    payThisMuch={payThisMuch}
                                                    billingDetails={billingDetails}
                                                    sendFlywireToken={sendFlywireToken}
                                                    returnURLDestination={`${siteUrl}/booking/confirmation/${bookingId}`}
                                                />
                                            </div>
                                        }
                                        {!allowPay && message && <Typography align={'center'} variant={'body1'}>
                                            <Icon sx={{ fontSize: '140px', marginTop: '20px', marginBottom: '20px' }}>warning_amber</Icon><br />
                                            {message}
                                        </Typography>}
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
                            {trip && Object.keys(trip).length > 0 && allowPay && <TripSummary showCosts />}
                            <Paper>
                                <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                                    Go Back to {prevStep.label}
                                </Button>
                            </Paper>
                        </Grid>
                    </Grid>
                )}
            </Container>
        </div>
    );
};

export default PaymentPageNew;